export const SAVE_SCROLL = 'SAVE_SCROLL'
export const SET_MAIN_PANEL = 'SET_MAIN_PANEL'
export const ADD_OFFCANVAS = 'ADD_OFFCANVAS'
export const UPDATE_OFFCANVAS = 'UPDATE_OFFCANVAS'
export const SET_OFFCANVAS_STATE = 'SET_OFFCANVAS_STATE'
